function expandableRows(element, $) { 
    var $el = $(element);
    var rowindex = 1;
    var moreRowsExists = false;
    var rowContainer = $el.prev('.expandable-rows');
    var cards = rowContainer.find('.om-product-list-card');

    function showNextRow() {
        if (!rowContainer || rowContainer.length == 0) {
            rowContainer = $el.prev('.expandable-rows');
        }
        if (!cards || cards.length == 0) {
            cards = rowContainer.find('.om-product-list-card');
        }

        rowindex++;
        var itemsPerRow = Math.floor(rowContainer.width() / cards.outerWidth(true));

        referenceHeight = cards.outerHeight(true);
        var newheight = rowindex * referenceHeight;
        moreRowsExists = rowindex * itemsPerRow < cards.length;
        rowContainer.css('height', newheight + 'px');
        return false;
    }

    if(rowContainer.length > 0){
        $el.children("a").on("click", function(evt) {
            evt.preventDefault();
            showNextRow();
            if(!moreRowsExists) {
                $el.hide();
            }
        });
    } else {
        $el.hide();
    }
}


$(function() {
    $('.corp-product-list-block .js-productlist-showmore').each(function(idx, item) {
        new expandableRows(item, $);
    });
})